export const getEventPath = (path) => path
    .slice(0, path.length - 4)
    .map((element) => (element === null || element === void 0 ? void 0 : element.localName) +
    ((element === null || element === void 0 ? void 0 : element.id) ? `#${element === null || element === void 0 ? void 0 : element.id}` : '') +
    ((element === null || element === void 0 ? void 0 : element.className) && typeof (element === null || element === void 0 ? void 0 : element.className) === 'string'
        ? `.${element.className.replace(' ', '.')}`
        : ''))
    .join(' ');
//# sourceMappingURL=getEventPath.js.map